import LegalPage from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy">
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>1. What we collect</h3>
      <p>TokenGuard collects only the data necessary to provide token monitoring services: your email, name, phone (optional), and LLM usage metrics. We do not store your API keys in plain text.</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>2. How we use data</h3>
      <p>Usage data is used to generate monitoring dashboards and trigger alerts. We never sell or share your data with third parties for advertising.</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>3. Data storage</h3>
      <p>Data is stored in encrypted databases. Credentials are encrypted at rest using AES-256.</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>4. Your rights</h3>
      <p>You can delete your account and all associated data at any time from the Profile screen.</p>
    </LegalPage>
  );
}
